import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'
import DashboardHome from '@/views/dashboard/dashboard-home'

export const Route = createFileRoute('/_authenticated/')({
    beforeLoad: async () => {
        const auth = useAuthStore.getState().auth;

        // Redirect super admin users to their specific dashboard
        if (auth.user?.role === 'Super Admin' || auth.user?.role_name === 'Super Admin') {
            throw redirect({
                to: '/super-admin-dashboard',
            })
        }
    },
    component: DashboardHome,
})
